// Indonesian formatters

export const formatIDR = (value, opts = {}) => {
  const { withSymbol = true, fractionDigits = 0 } = opts;
  const n = Number(value || 0);
  try {
    const formatted = new Intl.NumberFormat('id-ID', {
      style: withSymbol ? 'currency' : 'decimal',
      currency: 'IDR',
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
    }).format(n);
    return formatted;
  } catch (e) {
    return `Rp ${n.toLocaleString('id-ID')}`;
  }
};

export const formatIDRCompact = (value) => {
  const n = Number(value || 0);
  if (n >= 1_000_000_000) return `Rp ${(n / 1_000_000_000).toFixed(1)}M`;
  if (n >= 1_000_000) return `Rp ${(n / 1_000_000).toFixed(1)}Jt`;
  if (n >= 1_000) return `Rp ${(n / 1_000).toFixed(1)}K`;
  return `Rp ${n.toLocaleString('id-ID')}`;
};

// e-Faktur style with 2 decimals: "Rp 31.275.510,00"
export const formatIDR2 = (value) => formatIDR(value, { fractionDigits: 2 });

export const formatDateID = (value) => {
  if (!value) return '-';
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '-';
    return new Intl.DateTimeFormat('id-ID', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(d);
  } catch (e) {
    return '-';
  }
};

export const formatDateLongID = (value) => {
  if (!value) return '-';
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '-';
    return new Intl.DateTimeFormat('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }).format(d);
  } catch (e) {
    return '-';
  }
};

export const toInputDate = (value) => {
  if (!value) return '';
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  } catch (e) {
    return '';
  }
};

export const fromInputDate = (value) => {
  if (!value) return null;
  // Treat as UTC midnight
  return new Date(value + 'T00:00:00Z').toISOString();
};

export const parseIDRInput = (str) => {
  if (typeof str === 'number') return str;
  if (!str) return 0;
  // Remove non-digits except minus
  const cleaned = String(str).replace(/[^0-9-]/g, '');
  return Number(cleaned) || 0;
};
